import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {
	ApolloClient,
	InMemoryCache,
	ApolloProvider,
	HttpLink,
	ApolloLink,
	from,
} from "@apollo/client";
import "./i18n";
import { Envs } from "./conf/envs";
import { BrowserRouter } from "react-router-dom";
import { getStoredAuthToken } from "./services/auth-service";

const debugGraphql = process.env.NODE_ENV !== "production" &&
	process.env.REACT_APP_DEBUG_GRAPHQL === "true";

const loggerLink = new ApolloLink((operation, forward) => {
	if (!debugGraphql) {
		return forward(operation);
	}

	console.log(`GraphQL Request: ${operation.operationName}`, {
		operationName: operation.operationName,
	});

	return forward(operation).map((response) => {
		console.log(`GraphQL Response: ${operation.operationName}`, {
			hasErrors: !!response.errors?.length,
		});
		return response;
	});
});

const authLink = new ApolloLink((operation, forward) => {
	const token = getStoredAuthToken();
	
	if (token) {
		const parsedToken = token.startsWith('"') ? JSON.parse(token) : token;
		
		operation.setContext({
			headers: {
				Authorization: `Bearer ${parsedToken}`
			}
		});
	}
	
	return forward(operation);
});

const httpLink = new HttpLink({
	uri: `${Envs.API_BASE}/graphql`,
});

const client = new ApolloClient({
	cache: new InMemoryCache(),
	link: from([loggerLink, authLink, httpLink]),
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<ApolloProvider client={client}>
		<BrowserRouter>
			<App />
		</BrowserRouter>
	</ApolloProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
